export default __webpack_public_path__ + "static/assets/bfcb284faf2c09e0000dff73e316b1b4.svg";